var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinCreditedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2879_6001)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 26,
    rx: 8,
    fill: "#A3D69E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0918 19.5L7.90998 19.5L21.0918 19.5ZM7.90998 6.5L21.0918 6.5L7.90998 6.5Z",
    fill: "#06FF3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3233 17.75C9.44284 17.75 8.83175 17.3502 8.49001 16.5507C8.14697 15.7524 8.28523 15.0435 8.9048 14.4239L13.9918 9.33696C14.1874 9.14131 14.3994 8.99457 14.6276 8.89674C14.8559 8.79892 15.1005 8.75 15.3613 8.75C15.6222 8.75 15.8668 8.79892 16.095 8.89674C16.3233 8.99457 16.5352 9.14131 16.7309 9.33696L21.8178 14.4239C22.4374 15.0435 22.5757 15.7524 22.2326 16.5507C21.8909 17.3502 21.2798 17.75 20.3994 17.75L10.3233 17.75Z",
    fill: "#06FF3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2879_6001",
    x: -41.3744,
    y: -41.3744,
    width: 111.749,
    height: 108.749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20.6872
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2879_6001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2879_6001",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinCreditedIcon);
export default __webpack_public_path__ + "static/media/fin_credited_icon.e49340b2e2a6c6f49a4e96bbf556bde2.svg";
export { ForwardRef as ReactComponent };